import { render, staticRenderFns } from "./DotLoader.vue?vue&type=template&id=21b2b552"
import script from "./DotLoader.vue?vue&type=script&lang=js"
export * from "./DotLoader.vue?vue&type=script&lang=js"
import style0 from "./DotLoader.vue?vue&type=style&index=0&id=21b2b552&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports